module.exports = __webpack_public_path__ + "img/hunan.e7c2f132.png";